import React from "react";
import BmiForm from "./BmiForm.jsx";

const BmiInput = () => {
  return (
    <div className="bmi-input-wrap">
      <BmiForm />
    </div>
  );
};

export default BmiInput;
